import React, { useState, useEffect } from "react";
import {alertsActions, reservationsActions, useSelector} from "inbooma-api";
import { Biscuit, FormatHelper, Notification } from "../../../../utils";
import t from '../../../helpers/t';
import { getContentModifications } from '../../../../App';
import {_,moment,DropdownButton} from '../../../../../vendor';
import { getApiHost } from '../../../../Sync';
import * as OrderFunctions from "../../reservations/components/behaviors/OrderFunctions";


const ReservationListView = (props) => {

    // get order number of order appended to reservation
    const getOrderNumber = (reservation) => {
        if (typeof reservation.order != 'undefined' && reservation.order != null) {
            return reservation.order.order_nbr;
        }
        return '-';
    };

    // get pay status of order appended to reservation
    const getPayStatus = (reservation) => {
        if (typeof reservation.order !== 'undefined' && reservation.order !== null) {
            if (reservation.order.status !== 'paid') {
                if (reservation.order.price > 0) {
                    return t('open');
                } else {
                    return "";
                }
            } else {
                return t('paid');
            }
        }
    };

    // get link to user profile assigned to order appended to reservation
    const getOrderUserLink = (reservation) => {
        if (typeof reservation.order !== 'undefined' && reservation.order !== null) {
            if (typeof reservation.order.user === 'undefined' || reservation.order.user === null) {
              return '#';
            } else {
              return 'users/' + reservation.order.user.id;
            }
        }
        return '#';
    };

    // get user name of user assigned to order appended to reservation
    const getOrderUsername = (reservation) => {
        if (typeof reservation.order !== 'undefined' && reservation.order !== null) {
          if (typeof reservation.order.user === 'undefined' || reservation.order.user === null) {
            return t('customer_removed');
          } else {
            const user = reservation.order.user;
            if ( (user.first_name === undefined || user.first_name == null || user.first_name == '') &&
                 (user.last_name === undefined || user.last_name == null || user.last_name == '')) {
                       return user.customer_nbr;
                   }
            return reservation.order.user.first_name + " " + reservation.order.user.last_name;
          }
        }
        return '';
    };

    // get description of reservation or return list of summed contingents of reservation
    const getReservationDescription = (reservation) => {
        let _description = '';
        if (typeof reservation.contingents[0] !== 'undefined') {
            if (reservation.contingents[0].resourcetype_id == 3 && typeof reservation.checkins !== 'undefined' && reservation.checkins.length >= 1) {
                if (reservation.checkins[0] !== 'undefined') {
                    if (reservation.checkins[0].resource !== null && reservation.checkins[0].resource !== 'null') {
                        _description = t('app_order_bike_tour_${a}',{a:reservation.contingents[0].name});
                    }
                    else {
                        if (reservation.contingents[0].deleted !== null && reservation.contingents[0].deleted !== '') {
                            _description = t('app_order_bike_tour_min_${a}',{a: reservation.contingents[0].name + ', ' + t('contingent_removed')});
                        } else {
                            _description = t('app_order_bike_tour_${a}',{a:t('deleted_resource')}); // OR: Selection of resource in app has not yet been done
                        }
                    }
                }
            }
        }
        if (_description === '') {
            return printContingentsAmountList('', reservation);
        } else {
            return _description;
        }
    };

    // generate list of summed contingents
    const printContingentsAmountList = (memo, reservation) => {

        let r = ' ';

        // Fallback: Reservation was just created in this session so contingent._joinData is missing,
        // receive it from summedContingents
        // !!!! inside of reservationsList and dashboard there are no summed contingents !!!
        _.each(reservation.summedContingents, function (contingents) {
        
            if (typeof contingents.models[0] != 'undefined') {
                let size = FormatHelper.formatContingentTags(contingents.models[0].get('tags'));
                r = r + ((memo !== '' || r !== ' ') ? ', ' : '') + `${contingents.models[0].get('name')}${size} x ${contingents.length}`;
            }
        });

        if (r !== null && r !== ' ') {
            return memo + r;
        }

        if (typeof reservation.contingents[0] === 'undefined') {
            return memo;
        }

        let amountPerContingent = {};

        if (typeof reservation.contingents_reservations !== 'undefined' && reservation.contingents_reservations.length >= 1) {
            // Client-7 reservations (where reservation.contingents_reservations holds the acutal amount,
            // however reservation.contingents has the contingent information)

            _.each(reservation.contingents_reservations, function(contingent) {
                // Get amount per contingent
                if (typeof amountPerContingent[contingent.contingent_id] === 'undefined') {
                    amountPerContingent[contingent.contingent_id] = contingent.amount;
                } else {
                    amountPerContingent[contingent.contingent_id] += contingent.amount;
                }
            });

            _.each(amountPerContingent, function(amount, contingent_id) {
                // Get contingent data from contingents array

                let full_contingent = _.filter(reservation.contingents, function(contingent) {
                  return Number(contingent.id) === Number(contingent_id);
                })[0];
                
                if (typeof full_contingent !== 'undefined') {

                  let contingentDeleted = '';
                  
                  if (typeof full_contingent.deleted !== 'undefined'
                  && full_contingent.deleted !== null
                  && full_contingent.deleted !== '') {
                        contingentDeleted = ' (' + t('removed_${a}', {a:t('contingent')}) + ')';
                        reservation['_has_any_deleted_item'] = true;
                  }
                                
                  const size = FormatHelper.formatContingentTags(full_contingent.tags);

                  r += (r !== ' ' || memo !== '' ? ', ' : '') + full_contingent.name + size + contingentDeleted + ' x ' + amount;
                
                }

            });

        } else {

            // Regular (e.g. not-client-7) reservation
            _.each(reservation.contingents, function(contingent) {
                if (typeof contingent._joinData === 'undefined') return;
                r += (r !== ' ' || memo !== '' ? ', ' : '') + contingent.name + ' x ' + contingent._joinData.amount;
            });
        }

        return memo + r;
    };

    const getLocationNameById = (_locations,locationId) => {

        if (typeof _locations === 'undefined' || _locations == null || _locations.success !== true) return '';
        if (typeof locationId === 'undefined' || locationId == null) return '';

        // search location with matching id
        for (var i=0;i<_locations.data.length;i++) {
            if (_locations.data[i].id == locationId) return _locations.data[i].name;
        }
        console.log("Dashboard Reservations: Error: Can't resolve location with ID: " + locationId);
    };

    const getBeginLocationName = (reservation) => {

        return getLocationNameById(
            props.locations,
            reservation.location_id === null ? reservation.begin_location : reservation.location_id
        );
    };

    const getEndLocationName = (reservation) => {

        return getLocationNameById(
            props.locations,
            reservation.location_id === null ? reservation.end_location : reservation.location_id
        );
    };


    const getCheckinLocationName = (reservation) => {

        return getLocationNameById(
            props.locations,
            reservation.location_id = (reservation.checkins !== undefined && reservation.checkins.length > 0) ? reservation.checkins[0].location_checkin : null
        );
    };

    const getCheckoutLocationName = (reservation) => {

        return getLocationNameById(
            props.locations,
            reservation.location_id = (reservation.checkins !== undefined && reservation.checkins.length > 0) ? reservation.checkins[0].location_checkout : null
        );
    };

    const getLieferOrt = (reservation) => {

        let Lieferaddresse = '';

        if (typeof reservation.order !== 'undefined' && reservation.order !== null) {
            if (typeof reservation.order.order_addresses !== 'undefined') {
                _.each(reservation.order.order_addresses, function (value, key) {
                    if (value.type === 'begin') {
                        Lieferaddresse = value.street + ' ' + value.number + ', ' + value.city;
                    }
                });
            }
        }
        return Lieferaddresse;
    };

    const getAbholOrt = (reservation) => {

        let Abholaddresse = '';

        if (typeof reservation.order !== 'undefined' && reservation.order !== null) {
            if (typeof reservation.order.order_addresses !== 'undefined') {
                _.each(reservation.order.order_addresses, function (value, key) {
                    if (value.type === 'end') {
                        Abholaddresse = value.street + ' ' + value.number + ', ' + value.city;
                    }
                });
            }
        }
        return Abholaddresse;
    };

    const isHiddenElement = (id) => {
        let cm = getContentModifications();

        if (cm.hidden_elements != null && cm.hidden_elements.length > 0) {
          for (var i=0;i<cm.hidden_elements.length;i++) {
            if (cm.hidden_elements[i] == id) return true;
          }
        }
        return false;
    };

    const exchangeLabel = (value) => {
        let cm = getContentModifications();

        if (cm.labels != null) {
            if (cm.labels[value] !== undefined) {
                return cm.labels[value];
            }
        }
        return value;
    };

    const printRentalContract = (reservation) => {

        const ref = getApiHost().slice(0, -4) + '/rental_contract/' + reservation.id;
        window.open(ref, '_blank');
    };

    const statusHandler = (e,reservation) => {

        props.dispatch(reservationsActions.patchReservations({
            token: Biscuit.get('token'),
            suffix: "",
            reservation_id: Number(reservation.id),
            data: {status: e.target.value}
        }));
    };

    const getHeight = () => {
        
        const container = document.getElementsByClassName('inb-react-view-container');
        if (container.length > 0) {

            const containerHeight = container[0].offsetHeight;

            if (containerHeight > (props.minTopMargin + 330 + 30)) {
                return "330px";
            }
            return (containerHeight - props.minTopMargin) + "px";
        }
    };

    return (
        <>
            <aside id="inb-c-main-dashboard-orders" className="inb-widget inb-float-sidebar inb-float-sidebar--right large" style={{width:'calc(100% - 32px)',height:getHeight(),overflow:'scroll',left:'16px',bottom:'1.5rem'}}>
                {typeof props.reservations.map !== 'function' || props.reservations.length == 0 &&
                <div id="inb-app-collection-empty" className="inb-announcement" style={{marginTop:"25px"}}>
                    <div className="inb-image-box">
                        <img src="assets/img/no_data.svg"/>
                    </div>
                    <h3>{t('no_upcoming_reservations')}</h3>
                </div>
                }
                {typeof props.reservations.map == 'function' && props.reservations.map((reservation, index) => {
                  return (
                    <div className="inb-c-item inb-c-item--order row" key={index}>


                        <aside className="inb-c-item__actions">

                            <DropdownButton id="dropdown-basic-button" title="..." drop="right" menuAlign="right"  bsPrefix="button round inb-toggle-contingent-dd hover">
                                <ul className="inb-dropdown__list">
                                <li>
                                    <a href={"/reservationsList/" + reservation.id + "/edit"}>
                                        <i className="fi fi-pencil"></i>
                                        {t('order_edit', null, 'capital')}
                                    </a>
                                </li>
                                <li>
                                    <a href={"/reservationsList/" + reservation.id + "/addpayment"}>
                                        <i className="fi fi-dollar"></i>
                                        {t('add_payment', null, 'capital')}
                                    </a>
                                </li>
                                </ul>
                            </DropdownButton>
                        </aside>

                        <div className="medium-2 small-6 column inb-order-date">
                            {typeof reservation.begin !== 'undefined' && reservation.begin !== '' &&
                                <span className="inb-order-date__start inb-order-big" title={t('reservation') + " " + t('valid_from') + " " + moment(reservation.begin).format('MMMM Do YYYY, h:mm:ss a')}>
                                    {moment(reservation.begin).format('dd, DD.MM.YY')}
                                </span>
                            }
                            {typeof reservation.end !== 'undefined' && reservation.end !== '' && typeof reservation.begin !== 'undefined' && reservation.begin !== '' && moment(reservation.end).format('DD.MM.YY') != moment(reservation.begin).format('DD.MM.YY') &&
                                <span className="inb-order-date__start inb-order-big" title={t('reservation') + " " + t('valid_to') + " " + moment(reservation.end).format('MMMM Do YYYY, h:mm:ss a')}>
                                    {' - ' + moment(reservation.end).format('dd, DD.MM.YY')}
                                </span>
                            }
                            <br/>
                            {typeof reservation.begin !== 'undefined' && reservation.begin !== '' &&
                                <span className="inb-order-date__end" title={t('begin_booking') + " " + moment(reservation.begin).format('h:mm:ss a')}>
                                    {moment(reservation.begin).format('HH:mm')}
                                </span>
                            }
                            {typeof reservation.end !== 'undefined' && reservation.end !== '' && reservation.begin != reservation.end &&
                            <>
                                <span className="inb-order-date__end" title={t('end_booking') + " " + moment(reservation.end).format('h:mm:ss a')}>
                                    {" - " + moment(reservation.end).format('HH:mm')}
                                </span>
                                <br/>
                            </>
                            }
                        </div>

                        <div className="medium-1 small-6 medium-offset-0 column inb-order--object">
                            <span className="inb-order-small">
                                <a href={"/reservationsList/" + reservation.id + "/edit"}>
                                    {getOrderNumber(reservation)}
                                </a>
                            </span><br/>
                            <span className="inb-order-small">
                                {t('open') === getPayStatus(reservation) &&
                                    <a href={"/reservationsList/" + reservation.id + "/addpayment"}>
                                        {getPayStatus(reservation)}
                                    </a>
                                }
                                {t('open') !== getPayStatus(reservation) &&
                                    <span className="inb-order-date__end" title={getPayStatus(reservation)}>
                                        {getPayStatus(reservation)}
                                    </span>
                                }
                            </span>
                        </div>
                        <div className="medium-2 small-6 medium-offset-0 column inb-reservation--object">
                            <a target="_blank" href={getOrderUserLink(reservation)}>{getOrderUsername(reservation)}</a>
                            <br/>
                            {getReservationDescription(reservation)}
                        </div>
                        <div className="medium-2 small-6 medium-offset-0 column inb-reservation--location">
                            {getBeginLocationName(reservation)}
                            <br/>
                            {getLieferOrt(reservation)}
                        </div>
                        <div id="inb-res-item-column-end-location" className="medium-2 small-6 medium-offset-0 column inb-reservation--location">
                            {isHiddenElement('inb-res-item-column-end-location') === false &&
                                <>{getEndLocationName(reservation)}</>
                            }
                            <br/>
                            {isHiddenElement('inb-res-item-column-end-location') === false &&
                                <>{getAbholOrt(reservation)}</>
                            }
                        </div>
                        <div className="medium-2 small-6 medium-offset-0 column inb-order--status">
                            <div className="inb-status-select inb-before-badge" data-inb-status={reservation.status}>
                                <select className="inb-status-select" value={reservation.status == 'booking_process' ? 'inprogress' : reservation.status} onChange={(e) => statusHandler(e,reservation)}>
                                    <option value="requested" isdisabled={reservation.status == 'requested' ? 'true' : 'false'}>{t('requested',null,'capital')}</option>
                                    <option value="confirmed" isdisabled={reservation.status == 'confirmed' ? 'true' : 'false'}>{t('confirmed',null,'capital')}</option>
                                    {(reservation.status == 'booking_process' || reservation.status == 'inprogress' || reservation.status == 'confirmed' || reservation.status == 'completed') &&
                                    <>
                                        <option value="inprogress">{t(exchangeLabel('inprogress'),null,'capital')}</option>
                                        <option value="completed">{t('completed',null,'capital')}</option>
                                    </>
                                    }
                                    <option value="cancelled">{t('cancelled',null,'capital')}</option>
                                </select>
                            </div>
                        </div>
                        <div className="medium-1 small-6 medium-offset-0 column item-button-group">
                            <div className="button-container">
                                {reservation.status !== 'cancelled' && (Biscuit.get('client.isVehicleOwner') === 'true' || Biscuit.get('client.hasParkingLots') === 'true') &&
                                    <a href={'reservationsList/' + reservation.id + '/checkin'}
                                        title={(typeof reservation.checkins === 'undefined' || reservation.checkins.length === 0) ? t('checkin_reservation', null, 'capital') : t('checkout_reservation', null, 'capital')}>
                                            <button type="button" className="inb-round-btn hollow round float-left">
                                                <div className="inb-fi-checkin"></div>
                                            </button>
                                    </a>
                                }
                            </div>
                            <div className="button-container">
                                <a href='#'
                                    className="inb-reservation__pdf2"
                                    title={t('mietvertrag_help')}
                                    onClick={() => OrderFunctions._printRentalContract(reservation)}>
                                    <button type="button" className="inb-round-btn hollow round float-left">
                                        <div className="inb-fi-contract"></div>
                                    </button>
                                </a>
                            </div>
                        </div>                            

                        {typeof reservation.checkins !== 'undefined' && reservation.checkins.length > 0 &&
                          <>
                            <div className="inb-reservation inb-reservation--bikesharing inb-c-item-details-row row" style={{border: 'none',marginLeft: '16px',paddingBottom: '0',backgroundColor: '#f3f3f3'}}>
	                            <div className="tour__marker medium-3 medium-offset-1 column text-center" style={{marginLeft: '0'}} title={t('location_of_checkin')}>
		                            <div style={{display: 'flex',height: '100%',float: 'right',paddingBottom: '10px'}}>
			                        {(getCheckinLocationName(reservation) == '') &&
				                        <p style={{marginTop: 'auto',marginBottom: 'auto'}} title={t('location_yet_undefined')}>{t('location_yet_undefined')}</p>
			                        }
                                    {(getCheckinLocationName(reservation) != '') &&
                                        <p style={{marginTop: 'auto',marginBottom: 'auto'}}>{getCheckinLocationName(reservation)}</p>
                                    }
			                        <i className="fi fi-marker" style={{marginTop: 'auto',marginBottom: 'auto',marginLeft: '0.8rem',fontSize: '2.2rem'}}></i>
		                            </div>
                                </div>
                        
                                <div className="medium-6 column clearfix">
                                    <p className="tour__state text-center" style={{marginTop: '0',marginBottom: '0',paddingBottom: '0',fontSize: '0.8rem'}}>
                                    {(reservation.checkins[0].checkout !== '' && reservation.checkins[0].checkout != null) &&
                                    <>
                                        <button className="button round hollow" style={{padding: '2px 4px'}}>
                                            <i className="fi fi-check" style={{fontSize: '0.8rem'}}></i>
                                        </button>
                                        {t('completed',null,'capital') + (reservation.checkins[0].resource != null ? ': ' : '')}
                                    </>
                                    }
                                    {(reservation.checkins[0].checkout === '' || reservation.checkins[0].checkout == null) &&
                                    <>
                                        {t('tour_in_progress',null,'capital') + (reservation.checkins[0].resource != null ? ': ' : '')}
                                    </>
                                    }
                                    {(reservation.checkins[0].resource != null) &&
                                    <>
                                        <a href={"/resources/" + reservation.checkins[0].resource.id + "?path=/reservationsList"}>{reservation.checkins[0].resource.name}</a>
                                    </>
                                    }
                                    </p>

                                    <div className="tour__timeline"></div>
                                    <p className="float-left tour__checkin" title={moment(reservation.checkins[0].checkin).format('MMMM Do YYYY, h:mm:ss a')}>
                                        {moment(reservation.checkins[0].checkin).format('H:mm')}
                                        <br />
                                        {reservation.checkins[0].comment_checkin}
                                    </p>
                                    {(reservation.checkins[0].checkout !== '' && reservation.checkins[0].checkout != null) &&
                                    <>
                                        <p className="float-right tour__checkout" title={moment(reservation.checkins[0].checkout).format('MMMM Do YYYY, h:mm:ss a')} style={{float: 'right'}}>
                                            {moment(reservation.checkins[0].checkout).format('H:mm')}
                                            <br />
                                            {reservation.checkins[0].comment_checkout}
                                        </p>
                                        <a className="checkin-out-link" href={"/orders/" + reservation.order_id + "/checkin/" + reservation.id} style={{display: 'block',fontSize: '0.9rem',textAlign: 'center'}}>
                                            {t('see_completed_checkin_out',null,'capital')}
                                        </a>
                                    </>
                                    }
                                    {(reservation.checkins[0].checkout === '' || reservation.checkins[0].checkout == null) && (reservation.checkins[0].checkin !== '' && reservation.checkins[0].checkin != null) &&
                                        <p className="float-right tour__checkout" style={{float: 'right'}}>
                                            {t('tour_in_progress')}
                                            <a className="checkin-out-link" href={"/orders/" + reservation.order_id + "/checkin/" + reservation.id} style={{display: 'block',fontSize: '0.9rem',textAlign: 'center'}}>
                                                {t('checkout_reservation',null,'capital')}
                                            </a>
                                        </p>
                                    }
                                </div>

                                <div className="tour__marker medium-3 column text-center" style={{display: 'flex'}}	title={t('location_of_checkout')}>
                                    <div style={{display: 'flex',height: '100%',float: 'left',paddingBottom: '10px'}}>
                                    {(typeof reservation.checkins !== 'undefined' && reservation.checkins.length > 0 && reservation.checkins[0].checkout !== '' && reservation.checkins[0].checkout != null) &&
                                    <>
                                        <i className="fi fi-marker" style={{color:'blueviolet',marginRight: '0.8rem',marginTop: 'auto',marginBottom: 'auto',fontSize: '2.2rem'}}></i>
                                        {(getCheckoutLocationName(reservation) == '') &&
                                            <p style={{marginTop: 'auto',marginBottom: 'auto'}} title={t('location_yet_undefined')}>
                                                {t('location_yet_undefined')}
                                            </p>
                                        }
                                        {(getCheckinLocationName(reservation) != '') &&
                                            <p style={{marginTop: 'auto',marginBottom: 'auto'}}>
                                                {getCheckoutLocationName(reservation)}
                                            </p>
                                        }
                                    </>
                                    }
                                    {(typeof reservation.checkins === 'undefined' || reservation.checkins.length == 0 || reservation.checkins[0].checkout === '' || reservation.checkins[0].checkout == null) &&
                                        <i className="fi fi-marker" style={{color:'grey',opacity:'0.7',marginRight: '0.8rem',marginTop: 'auto',marginBottom: 'auto',fontSize: '2.2rem'}} title={t('tour_in_progress')}></i>
                                    }
                                    </div>
                                </div>
                            </div>
                          </>
                        }
                    </div>
                  )}
                )}
            </aside>
        </>
    );
};

export default ReservationListView;